module.exports = __webpack_public_path__ + "img/P4220145.b7e84a6b.jpg";